import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Notes from '../common/components/notes';
import { addDomainDetailNotesModal } from '../common/actions/modal-action-creators';

export const SenderDetailsNotesContainer = ( { openNotesModal, senderNotesData } ) => {
    return (
        <Notes
            addNote={openNotesModal}
            notesData={senderNotesData}
            dataAutomationId="my-sender-details-notes"
        />
    );
};

const MapDispatchToProps = {
    openNotesModal: addDomainDetailNotesModal,
};

SenderDetailsNotesContainer.propTypes = {
    openNotesModal: PropTypes.func.isRequired,
    senderNotesData: PropTypes.array,
};

export default connect( null, MapDispatchToProps )( SenderDetailsNotesContainer );
